import { Info } from '@mui/icons-material';
import { Box, Typography, TypographyProps } from '@mui/material';
import { useSkinStyles } from '../../hooks/useSkinStyles';
import { EMPTY_STATE_MESSAGE_SKIN_STYLES } from '../../styles/components/emptyStateMessage';

const EmptyStateMessage = ({ children, ...props }: TypographyProps) => {
  const styles = useSkinStyles(EMPTY_STATE_MESSAGE_SKIN_STYLES);

  return (
    <Box sx={styles.container}>
      <Info sx={styles.icon} />
      <Typography sx={styles.text} {...props}>
        {children}
      </Typography>
    </Box>
  );
};

export default EmptyStateMessage;
